import React, { useState, useEffect, useContext, useMemo } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import Header from '../../layout/Header/Header';
import {
  Button,
  Row,
  Table,
  Input,
  Label,
  ButtonGroup,
  Col,
} from 'reactstrap';
import Swal from 'sweetalert2';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import ExportJsonExcel from 'js-export-excel';
import axios from 'axios';
import useFullPageLoader from '../../hooks/useFullPageLoader';
import moment from 'moment';

function ReporteBalanceGanancias() {
  const { user } = useContext(AuthContext);
  const URL_CONTENEDORES = process.env.REACT_APP_URL_CONTENEDORES;
  const URL_GASTOS_CONTENEDOR = process.env.REACT_APP_URL_GASTOS_CONTENEDOR;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 365);
  const endDate = moment(hoy).format('YYYY-MM-DD');
  const startDate = moment(inicio).format('YYYY-MM-DD');

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState('');

  const [rows, setRows] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const matchTransporte = (nombre) => {
    if (!nombre) return false;
    return nombre.toLowerCase().includes('transporte');
  };
  const matchAgencia = (nombre) => {
    if (!nombre) return false;
    const n = nombre.toLowerCase();
    return n.includes('agencia') || n.includes('aduanal') || n.includes('agente');
  };

  useMemo(() => {
    showLoader();
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
    };

    Promise.all([
      axios.get(
        `${URL_CONTENEDORES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        { headers }
      ),
      axios.get(URL_GASTOS_CONTENEDOR, { headers }),
      axios.get(URL_CLIENTES, { headers }),
    ])
      .then(([respContenedores, respGastos, respClientes]) => {
        setClientes(respClientes.data);

        const gastosPorContenedor = {};
        respGastos.data.forEach((g) => {
          if (!g.contenedores || !g.contenedores[0]) return;
          const idCont = g.contenedores[0]._id;
          if (!gastosPorContenedor[idCont]) {
            gastosPorContenedor[idCont] = { agencia: 0, transporte: 0, otros: 0 };
          }
          const concepto =
            g.conceptosGastos && g.conceptosGastos[0]
              ? g.conceptosGastos[0].name
              : '';
          const monto = parseFloat(g.total) || 0;
          if (matchTransporte(concepto)) {
            gastosPorContenedor[idCont].transporte += monto;
          } else if (matchAgencia(concepto)) {
            gastosPorContenedor[idCont].agencia += monto;
          } else {
            gastosPorContenedor[idCont].otros += monto;
          }
        });

        const arr = respContenedores.data
          .filter((c) => c.is_active === 'Si')
          .map((c) => {
            const desglose =
              gastosPorContenedor[c._id] || { agencia: 0, transporte: 0, otros: 0 };
            const cobroShiff = parseFloat(c.totalCargos) || 0;
            const totalGastos = parseFloat(c.totalGastos) || 0;
            const sumDesglose =
              desglose.agencia + desglose.transporte + desglose.otros;
            if (sumDesglose === 0 && totalGastos > 0) {
              desglose.agencia = totalGastos;
            }
            const ganancia =
              cobroShiff -
              (desglose.agencia + desglose.transporte + desglose.otros);
            return {
              _id: c._id,
              idClientes: c.clientes && c.clientes[0] ? c.clientes[0]._id : '',
              cliente:
                c.clientes && c.clientes[0]
                  ? c.clientes[0].nombre_comercial
                  : '',
              numeroInterno:
                c.clientes && c.clientes[0]
                  ? `${c.clientes[0].nombre_comercial}-${c.idContenedor}`
                  : c.idContenedor,
              contenedor: c.contenedor,
              fecha: c.fecha,
              cobroAgencia: desglose.agencia,
              transporte: desglose.transporte,
              costosExtras: desglose.otros,
              cobroShiff: cobroShiff,
              ganancia: ganancia,
              observaciones: c.observaciones || '',
            };
          });

        setRows(arr);
        hideLoader();
      })
      .catch((err) => {
        console.log(err);
        hideLoader();
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  const filtered = useMemo(() => {
    return rows.filter(
      (r) => selectedCliente === '' || r.idClientes === selectedCliente
    );
  }, [rows, selectedCliente]);

  const totales = useMemo(() => {
    return filtered.reduce(
      (acc, r) => {
        acc.cobroAgencia += r.cobroAgencia;
        acc.transporte += r.transporte;
        acc.costosExtras += r.costosExtras;
        acc.cobroShiff += r.cobroShiff;
        acc.ganancia += r.ganancia;
        return acc;
      },
      {
        cobroAgencia: 0,
        transporte: 0,
        costosExtras: 0,
        cobroShiff: 0,
        ganancia: 0,
      }
    );
  }, [filtered]);

  const fmt = (n) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
    }).format(n || 0);

  function PDFTabla() {
    const body = filtered.map((r) => [
      r.cliente,
      r.numeroInterno,
      fmt(r.cobroAgencia),
      fmt(r.transporte),
      fmt(r.costosExtras),
      fmt(r.cobroShiff),
      fmt(r.ganancia),
      r.observaciones,
    ]);
    body.push([
      '',
      'TOTAL',
      fmt(totales.cobroAgencia),
      fmt(totales.transporte),
      fmt(totales.costosExtras),
      fmt(totales.cobroShiff),
      fmt(totales.ganancia),
      '',
    ]);
    const doc = new jsPDF('landscape');
    var img = new Image();
    img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
    doc.addImage(img, 'png', 230, 10, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
    doc.addImage(img2, 'png', 120, 10, 65, 25);
    doc.text(`Balance Ganancias Contenedores`, 20, 25);
    doc.setFontSize(10);
    doc.text(`${selectedFechaInicio} a ${selectedFechaFin}`, 20, 32);
    doc.autoTable({
      head: [[
        'Cliente',
        'Número Contenedor',
        'Cobro Total Agencia',
        'Transporte',
        'Costos Extras',
        'Cobro Shiff a Cliente',
        'Ganancia',
        'Comentarios',
      ]],
      body,
      startY: 40,
    });
    doc.save(`BalanceGanancias-${selectedFechaInicio}_${selectedFechaFin}.pdf`);
  }

  function excel() {
    const data = filtered.map((r) => ({
      Cliente: r.cliente,
      NumeroContenedor: r.numeroInterno,
      CobroTotalAgencia: r.cobroAgencia,
      Transporte: r.transporte,
      CostosExtras: r.costosExtras,
      CobroShiffCliente: r.cobroShiff,
      Ganancia: r.ganancia,
      Comentarios: r.observaciones,
    }));
    const option = {
      fileName: `BalanceGanancias-${selectedFechaInicio}_${selectedFechaFin}`,
      datas: [{
        sheetData: data,
        sheetName: 'Balance Ganancias',
        sheetFilter: [
          'Cliente',
          'NumeroContenedor',
          'CobroTotalAgencia',
          'Transporte',
          'CostosExtras',
          'CobroShiffCliente',
          'Ganancia',
          'Comentarios',
        ],
        sheetHeader: [
          'Cliente',
          'Número Contenedor',
          'Cobro Total Agencia',
          'Transporte',
          'Costos Extras',
          'Cobro Shiff a Cliente',
          'Ganancia',
          'Comentarios',
        ],
      }],
    };
    new ExportJsonExcel(option).saveExcel();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menuReportes ? (
        <div className='card col-12'>
          <Row>
            <Col sm='8'>
              <Button
                href='/MenuReportes'
                className='btn btn-danger'
                id='botonListado'
              >
                Regresar
              </Button>
            </Col>
            <Col sm='4' align='right'>
              <ButtonGroup>
                <Button size='sm' color='danger' onClick={PDFTabla}>
                  PDF
                </Button>
                <Button size='sm' color='primary' onClick={excel}>
                  Excel
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <h3 align='center'>Balance Ganancias Contenedores</h3>
          <Row>
            <Col md={3}>
              <Label>Fecha Inicio</Label>
              <Input
                bsSize='sm'
                type='date'
                value={selectedFechaInicio}
                onChange={(e) => setSelectedFechaInicio(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <Label>Fecha Fin</Label>
              <Input
                bsSize='sm'
                type='date'
                value={selectedFechaFin}
                onChange={(e) => setSelectedFechaFin(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <Label>Cliente</Label>
              <Input
                bsSize='sm'
                type='select'
                value={selectedCliente}
                onChange={(e) => setSelectedCliente(e.target.value)}
              >
                <option value=''>Todos</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.nombre_comercial}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Table size='sm' striped borderless className='table-responsive-xl'>
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Número Contenedor</th>
                <th>Cobro Total Agencia</th>
                <th>Transporte</th>
                <th>Costos Extras</th>
                <th>Cobro Shiff a Cliente</th>
                <th>Ganancia</th>
                <th>Comentarios</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r._id}>
                  <td>{r.cliente}</td>
                  <td>{r.numeroInterno}</td>
                  <td>{fmt(r.cobroAgencia)}</td>
                  <td>{fmt(r.transporte)}</td>
                  <td>{fmt(r.costosExtras)}</td>
                  <td>{fmt(r.cobroShiff)}</td>
                  <td>{fmt(r.ganancia)}</td>
                  <td>{r.observaciones}</td>
                </tr>
              ))}
              <tr>
                <th></th>
                <th>TOTAL</th>
                <th>{fmt(totales.cobroAgencia)}</th>
                <th>{fmt(totales.transporte)}</th>
                <th>{fmt(totales.costosExtras)}</th>
                <th>{fmt(totales.cobroShiff)}</th>
                <th>{fmt(totales.ganancia)}</th>
                <th></th>
              </tr>
            </tbody>
          </Table>
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default ReporteBalanceGanancias;
